import axios from 'axios';

export const request = function (config) {
    // 参数配置
    var tempConfig ={
        url: '',
        method: 'get',
        params: {},
        baseURL: 'https://crm.mansul.com/api/',
        timeout: 3000
    }
    Object.assign(tempConfig, config);
    return new Promise((resolve, reject) => {
        axios.request(tempConfig).then(res => {
            if (res.data.code == 1) {
                resolve(res.data)
            } else {
                this.$dialog.alert({
                    title:'提示',
                    message:'获取数据失败，请刷新',
                    confirmButtonColor:'red'
                })
            }
        }).catch(err => {

            this.$dialog.alert({
                title:'提示',
                message:'获取数据失败，请刷新',
                confirmButtonColor:'red'
            })
            reject(err)
        })
    })
}


